module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pdf"
  }, [_c('div', {
    attrs: {
      "id": "inch1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pdf-container"
  }, [_c('div', {
    staticClass: "pdf-viewer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRulers),
      expression: "showRulers"
    }],
    staticClass: "vertical-ruler"
  }, [_c('ruler', {
    style: ([_vm.offset.base, _vm.offset.v]),
    attrs: {
      "unit": _vm.unit,
      "length": _vm.doc.height.toPixel(),
      "scale": _vm.ratio,
      "zoom": _vm.zoom,
      "orientation": "vertical"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRulers),
      expression: "showRulers"
    }],
    staticClass: "horizontal-ruler"
  }, [_c('ruler', {
    style: ([_vm.offset.base, _vm.offset.h]),
    attrs: {
      "unit": _vm.unit,
      "length": _vm.doc.width.toPixel(),
      "scale": _vm.ratio,
      "zoom": _vm.zoom,
      "orientation": "horizontal"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "viewer"
    }
  }), _vm._v(" "), (_vm.view && _vm.view.url) ? _c('div', {
    staticClass: "pdf-viewer-overviewMap"
  }, [_c('OverviewMap', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOverview),
      expression: "showOverview"
    }],
    attrs: {
      "view": _vm.view,
      "generateUrl": _vm.generateThumbnailUrl,
      "onDragStop": _vm.handlePreviewerDragStop,
      "viewport": _vm.viewport
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pdf-bottom"
  }, [(_vm.url) ? _c('ThumbnailsSlider', {
    attrs: {
      "url": _vm.url,
      "pageCount": _vm.doc.pageCount,
      "generateUrl": _vm.generateThumbnailUrl,
      "currentPage": _vm.page,
      "changePage": _vm.changePage
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c61598e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pdf.vue
// module id = 423
// module chunks = 1